export var ReportsType;
(function (ReportsType) {
    ReportsType["NON_FINANCIAL"] = "Non-financial Reports";
    ReportsType["FINANCIAL"] = "Repayments and Financial Reports";
    ReportsType["PAYMENTS"] = "Transactions";
    ReportsType["INVOICES"] = "Invoices";
})(ReportsType || (ReportsType = {}));
